import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState, initialFilters } from './dashboardV2Data'
import { Contract, DashboardV2Filters, PaginationState } from './types'

const DashboardV2Slice = createSlice({
  name: 'dashboardV2',
  initialState,
  reducers: {
    setContracts: (state, action: PayloadAction<Contract[]>) => {
      state.contracts = action.payload
    },
    setFilters: (state, action: PayloadAction<DashboardV2Filters>) => {
      state.filters = action.payload
    },
    setPagination: (state, action: PayloadAction<PaginationState>) => {
      state.pagination = action.payload
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.pagination.currentPage = action.payload
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
    setUsersList: (state, action: PayloadAction<Record<string, unknown>>) => {
      state.usersList = action.payload
    },
    setProvidersList: (state, action: PayloadAction<Record<string, unknown>>) => {
      state.providersList = action.payload
    },
    setUrl: (state, action: PayloadAction<string>) => {
      state.url = action.payload
    },
    setPage: (state, action: PayloadAction<number | string>) => {
      state.page = action.payload
    },
    setCurrentContract: (state, action: PayloadAction<Record<string, unknown> | null>) => {
      state.currentContract = action.payload
    },
    clearDashboardV2: () => ({ ...initialState, filters: { ...initialFilters } }),
  },
})

export const {
  setContracts,
  setFilters,
  setPagination,
  setCurrentPage,
  setIsLoading,
  setError,
  setUsersList,
  setProvidersList,
  setUrl,
  setPage,
  setCurrentContract,
  clearDashboardV2,
} = DashboardV2Slice.actions

export default DashboardV2Slice.reducer
